(() => {
  const ready = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn();

  ready(() => {
    document.querySelectorAll('[data-landol-accordion-button]').forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('[data-landol-accordion-item]');
        if (!item) return;
        const panel = item.querySelector('[data-landol-accordion-panel]');
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        item.classList.toggle('is-open', !expanded);
        if (panel) panel.hidden = expanded;
      });
    });

    document.querySelectorAll('[data-landol-variant-select]').forEach((select) => {
      select.addEventListener('change', () => {
        const formId = select.getAttribute('data-form-id');
        if (!formId) return;
        const form = document.getElementById(formId);
        const input = form?.querySelector('input[name="id"]');
        if (input) input.value = select.value;
      });
    });
  });
})();

/* ── 메인 배너 슬라이드 ──
   외부 라이브러리 없이 돌린다. 배너 하나 때문에 캐러셀 라이브러리를 얹으면
   테마 로딩만 무거워진다. 자동넘김은 마우스를 올리거나 탭이 숨으면 멈춘다. */
(function () {
  function initHero(root) {
    if (root.dataset.heroReady) return;
    root.dataset.heroReady = "1";

    var slides = root.querySelectorAll("[data-slide]");
    var dots = root.querySelectorAll("[data-hero-dot]");
    if (slides.length < 2) return;

    var at = 0, timer = null;
    var wait = parseInt(root.dataset.interval, 10) || 6000;
    var auto = root.dataset.autoplay !== "false";

    function show(i) {
      at = (i + slides.length) % slides.length;
      for (var n = 0; n < slides.length; n++) slides[n].classList.toggle("is-active", n === at);
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle("is-active", d === at);
        dots[d].setAttribute("aria-selected", d === at ? "true" : "false");
      }
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { if (auto && !timer && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) timer = setInterval(function () { show(at + 1); }, wait); }
    function jump(i) { stop(); show(i); start(); }

    var prev = root.querySelector("[data-hero-prev]");
    var next = root.querySelector("[data-hero-next]");
    if (prev) prev.addEventListener("click", function () { jump(at - 1); });
    if (next) next.addEventListener("click", function () { jump(at + 1); });
    for (var k = 0; k < dots.length; k++) {
      (function (i) { dots[i].addEventListener("click", function () { jump(i); }); })(k);
    }

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);
    root.addEventListener("focusin", stop);
    root.addEventListener("focusout", start);
    document.addEventListener("visibilitychange", function () { document.hidden ? stop() : start(); });

    /* 손가락으로 옆으로 밀기 — 세로 스크롤과 헷갈리지 않게 가로 이동이 클 때만 넘긴다 */
    var x0 = null, y0 = null;
    root.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    root.addEventListener("touchend", function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) jump(dx < 0 ? at + 1 : at - 1);
      x0 = y0 = null;
    }, { passive: true });

    show(0);
    start();
  }

  function scan() {
    var list = document.querySelectorAll("[data-landol-hero]");
    for (var i = 0; i < list.length; i++) initHero(list[i]);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scan);
  else scan();
  /* 테마 편집기에서 섹션을 다시 그리면 새로 붙여야 한다 */
  document.addEventListener("shopify:section:load", scan);
})();
